document.addEventListener("DOMContentLoaded", async function () {
  const apiBaseUrl = "https://1f3e03lxm8.execute-api.us-east-2.amazonaws.com/default/cm-new-users-app";

  const blocks = document.querySelectorAll(".new-user-panel__block");
  blocks.forEach((block) => {
    block.classList.add("loading");
  });

  //get user info

  async function fetchUserInfo() {
    const customerId = window.userId;
    if (!customerId) {
      console.log("No customer ID");
      return null;
    }

    try {
      const response = await fetch(`${apiBaseUrl}?customerId=${customerId}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      const data = await response.json();
      return {
        created_at: new Date(data.created_at),
        total_spent: parseFloat(data.total_spent),
      };
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  }

  const userInfo = await fetchUserInfo();

  if (userInfo?.created_at) {
    const customerCreatedAtWrapper = document.querySelector(
      "#customer-createdAt"
    );
    customerCreatedAtWrapper.innerHTML = `${userInfo.created_at.toLocaleDateString()}`;

    //show alert based on userCreatedAt date
    const popupAlert = document.querySelector(".new-user-panel__alert");
    const today = new Date();
    const diffInMs = today - userInfo.created_at;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays >= 30 && diffInDays < 45) {
      document.addEventListener("pageHidden", () => {
        if (popupAlert) {
          popupAlert.classList.add("active");
        }
      });

      const closeButton = document.querySelector(
        ".new-user-panel__alert-close"
      );

      if (popupAlert) {
        function closePopup() {
          popupAlert.classList.remove("active");
        }

        closeButton.addEventListener("click", closePopup);

        popupAlert.addEventListener("click", (event) => {
          if (!event.target.closest(".new-user-panel__alert-content")) {
            closePopup();
          }
        });
      }
    }
  } else {
    const customerCreatedAtWrapper = document.querySelector(
      "#customer-createdAt"
    );
    customerCreatedAtWrapper.innerHTML = "There is an error. Try again later.";
    customerCreatedAtWrapper.style.color = "red";
  }

  if (typeof userInfo?.total_spent === "number") {
    const maxAmount = 1500;
    let totalSpent = userInfo.total_spent;
    const successMessage = document.querySelector("#success-message");

    if (totalSpent >= maxAmount) {
      totalSpent = maxAmount;

      if (successMessage) {
        successMessage.classList.add("active");
      }
    }

    document.getElementById(
      "user-progress"
    ).textContent = `$${totalSpent.toFixed(2)}`;

    let progress = (userInfo.total_spent / maxAmount) * 100;
    progress = Math.min(progress, 100);

    document.getElementById("user-progress-fill").style.width = `${progress}%`;
  }

  blocks.forEach((block) => {
    block.classList.remove("loading");
  });
  
  
document.querySelectorAll('.new-user-panel__tooltip').forEach(tooltip => {
  const tooltipText = tooltip.querySelector('.new-user-panel__tooltip-text');

  tooltip.addEventListener('mouseenter', () => {
    tooltipText.classList.add('visible');

    requestAnimationFrame(() => {
      const rect = tooltipText.getBoundingClientRect();
      const left = rect.left;
      const fullWidth = tooltipText.offsetWidth;
      const rightEdge = left + fullWidth;
      const viewportWidth = window.innerWidth;

      if (rightEdge > viewportWidth) {
        const overflowRight = rightEdge - viewportWidth;
        tooltipText.style.left = `calc(50% - (${overflowRight}px + 21px))`;
        tooltipText.style.transform = `translateX(-50%)`;
      } else if (left < 0) {
        const overflowLeft = Math.abs(left);
        tooltipText.style.left = `calc(50% + (${overflowLeft}px + 21px))`;
        tooltipText.style.transform = `translateX(-50%)`;
      } else {
        tooltipText.style.left = `50%`;
        tooltipText.style.transform = `translateX(-50%)`;
      }
    });
  });

  tooltip.addEventListener('mouseleave', () => {
    tooltipText.classList.remove('visible');
    tooltipText.style.left = `50%`;
    tooltipText.style.transform = `translateX(-50%)`;
  });
});

});
